export default "__VITE_ASSET__CUfGU7vF__"